import DownloadFilesTable from 'components/common/download-files/DownloadFilesTable';
import styled from 'styled-components';

export const DownloadFilesTableStyled = styled(DownloadFilesTable)`
  margin-bottom: 8rem;
`;
